module.exports = __webpack_public_path__ + "img/promo_tlgrm.ef6f9a4b.png";